<div class="container">
  <div class="title">
    <h3>Sign-in</h3>
  </div>

  @if (flags != []) {
    @for (flag of flags; track flag) {
      <div style="margin-bottom: 0.5rem">
        <p-message icon="pi pi-info-circle" severity="info" size="small" [text]="flagLabelMapping[flag]" />
      </div>
    }
    <p-divider />
  }

  <form #credentialsForm [formGroup]="formGroup" pForm (ngSubmit)="startSession($event)">
    @if ((selectedAuthProvider?.getSignInFields()?.length ?? 0) > 0) {
      @for (control of selectedAuthProvider?.getSignInFields(); track control.key) {
        <div>
          <p class="pt-0-5">
            <p-input-group class="field">
              <p-inputgroup-addon>
                <i [class]="control.icon ?? 'pi pi-pencil'"></i>
              </p-inputgroup-addon>
              <p-floatlabel variant="on">
                @switch (control.type) {
                  @case ('text') {
                    <input required="true" pInputText [formControlName]="control.key" type="text" [id]="control.key" />
                    <label [for]="control.key">{{ control.label }}</label>
                  }
                  @case ('email') {
                    <input required="true" pInputText [formControlName]="control.key" type="email" [id]="control.key" />
                    <label [for]="control.key">{{ control.label }}</label>
                  }
                  @case ('checkbox') {
                    <input
                      required="true"
                      pInputText
                      [formControlName]="control.key"
                      type="checkbox"
                      [id]="control.key"
                    />
                    <label [for]="control.key">{{ control.label }}</label>
                  }
                  @case ('password') {
                    <input
                      required="true"
                      pInputText
                      [formControlName]="control.key"
                      type="password"
                      [id]="control.key"
                    />
                    <label [for]="control.key">{{ control.label }}</label>
                  }
                }
              </p-floatlabel>
            </p-input-group>
            @if (formGroup.get(control.key)?.invalid && formGroup.get(control.key)?.touched) {
              @switch (control.type) {
                @case ('text') {
                  <small class="form-error">Please enter a valid {{ control.label.toLowerCase() }}</small>
                }
                @case ('email') {
                  <small class="form-error">Please enter a valid {{ control.label.toLowerCase() }}</small>
                }
                @case ('checkbox') {
                  <small class="form-error">Please check the {{ control.label.toLowerCase() }}</small>
                }
                @case ('password') {
                  <small class="form-error">Please enter a valid {{ control.label.toLowerCase() }}</small>
                }
              }
            }
          </p>
        </div>
      }

      <p-divider type="solid" dir="ltr" />

      <div style="justify-content: center">
        <p-checkbox
          [value]="saveCredentials"
          (onChange)="onChangeSaveCredentials($event.checked)"
          binary="true"
          inputId="save-credentials-checkbox"
        />
        <label style="margin-left: 0.5rem" for="save-credentials-checkbox">Remember Credentials</label>
      </div>
    }

    <p-divider />

    <div>
      <p-button
        type="submit"
        fluid="true"
        label="Sign-in"
        [loading]="loading"
        [disabled]="!isValid() || loading || selectedAuthProvider === null"
      />
    </div>

    @if (errorMessage !== null) {
      <div class="error-message-box">
        <strong>Error</strong>
        <p>
          {{ errorMessage }}
        </p>
      </div>
    }
  </form>

  <p-divider />

  <div style="text-align: center">
    <div><small>Or</small></div>
    <p-button link (click)="router.navigate(['session', 'select'])">Select a session</p-button>
    @if (selectedAuthProvider?.supportsPasswordReset) {
      <div>
        <p-button link (click)="router.navigate(['session', 'reset-password'])">Forgot password?</p-button>
      </div>
    }
  </div>
</div>
